@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.tooltipIconWrapper {
  display: inline-flex;
  flex-shrink: 0;
  border-radius: sizes.$s2;
  cursor: help;
}

// Row holding the <label> and its tooltip icon as siblings. It replaces the label as the
// wrapper's direct child, so it carries the label's bottom margin.
.labelRow {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: sizes.$s3;
}

.wrapper {
  > .labelRow {
    margin-bottom: sizes.$s4;
  }

  div.label {
    margin-bottom: 0;
  }

  :global {
    .label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: sizes.$s3;
    }

    .tooltip {
      color: var(--secondary-text-color);
    }

    .error-text {
      color: red;
      font-size: fonts.$mid;
      margin-top: 0.25rem;
    }
  }
}
